module.exports = __webpack_public_path__ + "c5d4606b0023aa03a689f38213a15140.svg";